<div class="relative surface-0 h-full">
<!--    <div id="attr-menu" class="attr-menu hidden"></div>-->
    <div id="attr-menu" class="ql-mention-list-container hidden">
        <ul class="ql-mention-list"></ul>
    </div>
    <div #editorHost class="resizable-editor" (contextmenu)="onEditorRightClick($event, cm)" style="height: calc(92vh - 20rem)"></div>
    <div *ngIf="busy" class="absolute right-0 left-0 top-0 bottom-0 flex align-items-center justify-content-center w-full">
        <p-progressSpinner class="flex w-5rem h-5rem" ></p-progressSpinner>
    </div>
</div>
<p-contextMenu #cm [model]="contextMenuItems"></p-contextMenu>

<p-drawer [(visible)]="openBottomBar" position="bottom" [style]="{'min-height' : '720px'}" [fullScreen]="fullDialog" >
    <ng-template pTemplate="header">
        <div class="flex w-full justify-content-between px-2">
            <h5 class="font-medium">DrawIO</h5>
            <p-button
                    (click)="handleFullDialog()"
                    [icon]="fullDialog ? 'pi pi-window-minimize' : 'pi pi-window-maximize'"
                    styleClass="p-button-icon-only cursor-pointer p-button-text w-auto">
            </p-button>
        </div>
    </ng-template>
    <mvs-drawio class="col-3" *ngIf="openBottomBar" [diagramXML]="diagramXML" (drawIOData)="handleDrawIoData($event)"></mvs-drawio>
</p-drawer>